import { render, staticRenderFns } from "./TagNew.vue?vue&type=template&id=1e3d167c&"
var script = {}
import style0 from "./TagNew.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports